// src/pages/SeoPresencia.js
import { useState, useEffect } from 'react';

const API = 'https://bot.devit.es/api';
function headers() {
  return { 'Authorization': `Bearer ${localStorage.getItem('devit_token')}`, 'Content-Type': 'application/json' };
}

function Btn({ children, onClick, variant = 'primary', disabled = false, style = {} }) {
  const styles = {
    primary:   { background: '#7c3aed', color: '#fff', border: 'none' },
    secondary: { background: '#1a1d2e', color: '#9b9fc4', border: '1px solid #2a2e4a' },
    danger:    { background: 'transparent', color: '#f87171', border: '1px solid #5a2a2a' },
  };
  return (
    <button onClick={onClick} disabled={disabled} style={{
      ...styles[variant], padding: '8px 18px', borderRadius: 8,
      cursor: disabled ? 'not-allowed' : 'pointer', fontSize: 14, fontWeight: 600,
      opacity: disabled ? 0.5 : 1, transition: 'opacity 0.15s', ...style,
    }}>
      {children}
    </button>
  );
}

function Card({ children, style = {} }) {
  return (
    <div style={{ background: '#1a1d2e', border: '1px solid #2a2e4a', borderRadius: 12, padding: 24, ...style }}>
      {children}
    </div>
  );
}

export default function SeoPresencia() {
  const [paginas, setPaginas]       = useState([]);
  const [loading, setLoading]       = useState(true);
  const [generando, setGenerando]   = useState(false);
  const [keyword, setKeyword]       = useState('');
  const [localidad, setLocalidad]   = useState('');
  const [error, setError]           = useState('');
  const [copiado, setCopiado]       = useState('');
  const [urlNueva, setUrlNueva]     = useState('');
  const [dominio, setDominio]       = useState('');
  const [dominioGuardado, setDominioGuardado] = useState(null);
  const [dominioSsl, setDominioSsl] = useState(false);
  const [dominioLoading, setDominioLoading]   = useState(false);
  const [dominioError, setDominioError]       = useState('');
  const [dominioOk, setDominioOk]             = useState('');
  const [branding, setBranding]   = useState({ nombre:'', color_principal:'#7c3aed', telefono:'', web:'', logo_url:'' });
  const [brandingOk, setBrandingOk]   = useState('');
  const [brandingErr, setBrandingErr] = useState('');
  const [brandingSaving, setBrandingSaving] = useState(false);
  const [logoFile, setLogoFile]   = useState(null);
  const [bulkSugerencias, setBulkSugerencias] = useState(null);
  const [bulkSeleccionadas, setBulkSeleccionadas] = useState([]);
  const [bulkSugeriendo, setBulkSugeriendo] = useState(false);
  const [bulkWarning, setBulkWarning] = useState('');
  const [bulkJobId, setBulkJobId]     = useState(null);
  const [bulkProgress, setBulkProgress] = useState({ total: 0, done: 0, errors: [], status: '' });
  const [bulkGenerando, setBulkGenerando] = useState(false);
  const [visitas, setVisitas]           = useState({});
  const [visitasPeriodo, setVisitasPeriodo] = useState('7d');
  const [visitasExpandida, setVisitasExpandida] = useState(null);

  useEffect(() => {
    cargar();
    cargarVisitas('7d');
    fetch(`${API}/tenants/seo/branding`, { headers: headers() })
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d) setBranding(d); });
    fetch(`${API}/tenants/seo/dominio`, { headers: headers() })
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d) { setDominioGuardado(d.dominio); setDominioSsl(d.ssl); } });
  }, []);

  async function cargarVisitas(periodo) {
    try {
      const r = await fetch(`${API}/tenants/seo/visitas?periodo=${periodo}`, { headers: headers() });
      if (r.ok) {
        const d = await r.json();
        const map = {};
        d.paginas.forEach(p => { map[p.page_id] = p; });
        setVisitas(map);
      }
    } catch {}
  }

  function cambiarPeriodo(p) {
    setVisitasPeriodo(p);
    cargarVisitas(p);
  }

  async function cargar() {
    setLoading(true);
    try {
      const r = await fetch(`${API}/tenants/seo/paginas`, { headers: headers() });
      if (r.ok) setPaginas(await r.json());
    } finally {
      setLoading(false);
    }
  }

  async function generar() {
    if (!keyword.trim() || !localidad.trim()) { setError('Introduce la keyword y la localidad.'); return; }
    setError('');
    setUrlNueva('');
    setGenerando(true);
    try {
      const r = await fetch(`${API}/tenants/seo/generar`, {
        method: 'POST',
        headers: headers(),
        body: JSON.stringify({ keyword: keyword.trim(), localidad: localidad.trim() }),
      });
      const data = await r.json();
      if (!r.ok) { setError(data.detail || 'Error generando la página.'); return; }
      setUrlNueva(data.url);
      setKeyword('');
      setLocalidad('');
      cargar();
    } catch {
      setError('Error de conexión.');
    } finally {
      setGenerando(false);
    }
  }

  async function eliminar(id) {
    if (!window.confirm('¿Eliminar esta página?')) return;
    await fetch(`${API}/tenants/seo/paginas/${id}`, { method: 'DELETE', headers: headers() });
    cargar();
  }

  function copiar(url, id) {
    navigator.clipboard.writeText(url);
    setCopiado(id);
    setTimeout(() => setCopiado(''), 2000);
  }

  async function sugerir() {
    setBulkSugeriendo(true); setBulkWarning('');
    try {
      const r = await fetch(`${API}/tenants/seo/sugerir`, { method: 'POST', headers: headers() });
      const d = await r.json();
      if (r.ok) {
        setBulkSugerencias(d.sugerencias);
        if (d.warning) setBulkWarning(d.warning);
        setBulkSeleccionadas(
          d.sugerencias.map((s, i) => (!s.existe ? i : null)).filter(i => i !== null)
        );
      }
    } catch { setBulkWarning('Error al obtener sugerencias.'); }
    finally { setBulkSugeriendo(false); }
  }

  function toggleSel(idx, checked) {
    setBulkSeleccionadas(prev => checked ? [...prev, idx] : prev.filter(i => i !== idx));
  }

  async function generarBulk() {
    const pairs = bulkSeleccionadas.map(i => ({
      keyword: bulkSugerencias[i].keyword,
      localidad: bulkSugerencias[i].localidad,
    }));
    setBulkGenerando(true);
    try {
      const r = await fetch(`${API}/tenants/seo/generar-bulk`, {
        method: 'POST', headers: headers(), body: JSON.stringify({ pairs }),
      });
      const d = await r.json();
      if (!r.ok) { alert(d.detail || 'Error al iniciar generación'); setBulkGenerando(false); return; }
      setBulkJobId(d.job_id);
      setBulkProgress({ total: d.total, done: 0, errors: [], status: 'running' });
      setBulkSugerencias(null); setBulkSeleccionadas([]);
      const poll = setInterval(async () => {
        const rp = await fetch(`${API}/tenants/seo/bulk-status/${d.job_id}`, { headers: headers() });
        const dp = await rp.json();
        setBulkProgress(dp);
        if (dp.status === 'done' || dp.status === 'error') {
          clearInterval(poll); setBulkGenerando(false); cargar();
        }
      }, 3000);
      setTimeout(() => clearInterval(poll), 30 * 60 * 1000);
    } catch { setBulkGenerando(false); }
  }

  return (
    <div style={{ padding: '24px', maxWidth: 860, margin: '0 auto' }}>

      {/* ── Header ── */}
      <div style={{ marginBottom: 28 }}>
        <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: 'var(--text)' }}>Presencia en Google</h2>
        <p style={{ margin: '6px 0 0', fontSize: 13, color: 'var(--text2)' }}>
          Genera páginas SEO optimizadas indexadas en Google con tu chatbot integrado.
          Conecta tu dominio para que la autoridad SEO construya en tu marca, no en la nuestra.
        </p>
      </div>

      {/* ── 1. Branding ── */}
      <div style={{ marginBottom: 16, background: '#1a1d2e', border: '1px solid #2a2e4a', borderRadius: 12, padding: 24 }}>
        <div style={{ fontWeight: 700, fontSize: 15, color: 'var(--text)', marginBottom: 16 }}>
          🎨 Personalizar mis páginas
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
          <div>
            <label style={{ display:'block', fontSize:12, color:'var(--text2)', marginBottom:5, fontWeight:600 }}>Nombre del negocio</label>
            <input value={branding.nombre} onChange={e => setBranding({...branding, nombre: e.target.value})}
              placeholder="Inmobiliaria Peritone"
              style={{ width:'100%', padding:'10px 14px', borderRadius:8, fontSize:14,
                background:'#0f1120', border:'1px solid #2a2e4a', color:'var(--text)', boxSizing:'border-box' }} />
          </div>
          <div>
            <label style={{ display:'block', fontSize:12, color:'var(--text2)', marginBottom:5, fontWeight:600 }}>Teléfono</label>
            <input value={branding.telefono} onChange={e => setBranding({...branding, telefono: e.target.value})}
              placeholder="+34 612 345 678"
              style={{ width:'100%', padding:'10px 14px', borderRadius:8, fontSize:14,
                background:'#0f1120', border:'1px solid #2a2e4a', color:'var(--text)', boxSizing:'border-box' }} />
          </div>
          <div>
            <label style={{ display:'block', fontSize:12, color:'var(--text2)', marginBottom:5, fontWeight:600 }}>Web del negocio</label>
            <input value={branding.web} onChange={e => setBranding({...branding, web: e.target.value})}
              placeholder="https://tudominio.com"
              style={{ width:'100%', padding:'10px 14px', borderRadius:8, fontSize:14,
                background:'#0f1120', border:'1px solid #2a2e4a', color:'var(--text)', boxSizing:'border-box' }} />
          </div>
          <div>
            <label style={{ display:'block', fontSize:12, color:'var(--text2)', marginBottom:5, fontWeight:600 }}>Color principal</label>
            <div style={{ display:'flex', gap:8, alignItems:'center' }}>
              <input type="color" value={branding.color_principal}
                onChange={e => setBranding({...branding, color_principal: e.target.value})}
                style={{ width:44, height:40, borderRadius:6, border:'1px solid #2a2e4a',
                  background:'#0f1120', cursor:'pointer', padding:2 }} />
              <input value={branding.color_principal} onChange={e => setBranding({...branding, color_principal: e.target.value})}
                style={{ flex:1, padding:'10px 14px', borderRadius:8, fontSize:13,
                  background:'#0f1120', border:'1px solid #2a2e4a', color:'var(--text)', boxSizing:'border-box' }} />
            </div>
          </div>
        </div>

        <div style={{ marginTop: 14 }}>
          <label style={{ display:'block', fontSize:12, color:'var(--text2)', marginBottom:5, fontWeight:600 }}>Logo</label>
          <div style={{ display:'flex', gap:12, alignItems:'center', flexWrap:'wrap' }}>
            {branding.logo_url && (
              <img src={branding.logo_url} alt="logo" style={{ height:40, borderRadius:6,
                background:'#0f1120', padding:4, border:'1px solid #2a2e4a' }} />
            )}
            <label style={{ padding:'8px 16px', borderRadius:8, background:'#1a1d2e',
              border:'1px solid #2a2e4a', color:'var(--text2)', fontSize:13, cursor:'pointer', fontWeight:600 }}>
              {branding.logo_url ? 'Cambiar logo' : 'Subir logo'}
              <input type="file" accept="image/*" style={{ display:'none' }}
                onChange={e => setLogoFile(e.target.files[0])} />
            </label>
            {logoFile && <span style={{ fontSize:12, color:'#4ade80' }}>✓ {logoFile.name}</span>}
          </div>
        </div>

        <div style={{ marginTop: 16, display:'flex', gap:10, alignItems:'center' }}>
          <Btn onClick={async () => {
            setBrandingSaving(true); setBrandingOk(''); setBrandingErr('');
            try {
              let brandingFinal = { ...branding };
              if (logoFile) {
                const b64 = await new Promise((res, rej) => {
                  const reader = new FileReader();
                  reader.onload = e => res(e.target.result);
                  reader.onerror = rej;
                  reader.readAsDataURL(logoFile);
                });
                const rl = await fetch(`${API}/tenants/seo/branding/logo`, { method:'POST',
                  headers: headers(), body: JSON.stringify({ file_b64: b64 }) });
                const dl = await rl.json();
                if (rl.ok) { brandingFinal = { ...brandingFinal, logo_url: dl.logo_url }; setBranding(brandingFinal); }
                else { setBrandingErr(dl.detail || 'Error subiendo el logo'); setBrandingSaving(false); return; }
              }
              const r = await fetch(`${API}/tenants/seo/branding`, { method:'PUT', headers: headers(),
                body: JSON.stringify(brandingFinal) });
              if (r.ok) { setBrandingOk('Guardado correctamente'); setLogoFile(null); }
              else setBrandingErr('Error al guardar');
            } catch { setBrandingErr('Error de conexión'); }
            finally { setBrandingSaving(false); }
          }} disabled={brandingSaving}>
            {brandingSaving ? 'Guardando...' : 'Guardar cambios'}
          </Btn>
          {brandingOk  && <span style={{ fontSize:13, color:'#4ade80' }}>{brandingOk}</span>}
          {brandingErr && <span style={{ fontSize:13, color:'#f87171' }}>{brandingErr}</span>}
        </div>
      </div>

      {/* ── 2. Dominio propio ── */}
      <div style={{ marginBottom: 24, background: '#1a1d2e', border: '1px solid #2a2e4a', borderRadius: 12, padding: 24 }}>
        <div style={{ fontWeight: 700, fontSize: 15, color: 'var(--text)', marginBottom: 8 }}>
          🌐 Conecta tu propio dominio
        </div>
        <div style={{ marginBottom: 16, padding: '14px 16px', borderRadius: 8,
          background: '#0f1120', border: '1px solid #2a2e4a', fontSize: 13, color: 'var(--text2)', lineHeight: 1.7 }}>
          <strong style={{ color: 'var(--text)', display: 'block', marginBottom: 6 }}>¿Por qué conectar tu dominio?</strong>
          Sin dominio propio, tus páginas viven en <code style={{ color: '#a78bfa' }}>devit.es/empresas/tuempresa/</code> y la autoridad SEO que ganes va al dominio de Devit.
          Al conectar tu subdominio (ej. <code style={{ color: '#a78bfa' }}>seo.tuempresa.com</code>), cada visita, posición en Google y enlace que acumules construye autoridad en <strong>tu propia marca</strong> — no en la nuestra.
          Cuantas más páginas y más tiempo acumules, más difícil es que un competidor te supere.
          <br /><br />
          <strong style={{ color: '#fbbf24' }}>¿Qué pasa si cancelas Devit?</strong><br />
          Las páginas dejarán de servirse y Google las desindexará progresivamente. Sin embargo, puedes descargar todas tus páginas en HTML
          y subirlas a tu propio hosting para no perder el trabajo acumulado.
          <span style={{ display: 'block', marginTop: 6, color: '#9b9fc4' }}>
            Usá el botón "Descargar mis páginas" cuando quieras — te damos el ZIP con todo listo para publicar.
          </span>
        </div>
        <p style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 16, lineHeight: 1.6 }}>
          Añade este registro en el DNS de tu dominio y luego introduce el subdominio aquí.
          Devit generará el certificado SSL automáticamente.
        </p>

        <div style={{ background: '#0f1120', border: '1px solid #2a2e4a', borderRadius: 8,
          padding: '12px 16px', fontFamily: 'monospace', fontSize: 13, color: '#a78bfa', marginBottom: 16 }}>
          <div style={{ color: '#6b7280', fontSize: 11, marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Registro DNS a añadir</div>
          <div><span style={{ color: '#4ade80' }}>Tipo:</span> A</div>
          <div><span style={{ color: '#4ade80' }}>Nombre:</span> seo</div>
          <div><span style={{ color: '#4ade80' }}>Datos / Valor:</span> 78.47.9.173</div>
          <div style={{marginTop:6,color:'#6b7280',fontSize:11}}>⚠️ Usa tipo A, no CNAME. En GoDaddy el campo se llama &quot;Datos&quot;.</div>
        </div>

        {dominioGuardado ? (
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
              <div style={{ flex: 1, padding: '10px 14px', borderRadius: 8,
                background: '#0f1120', border: '1px solid #2a2e4a', fontSize: 13, color: 'var(--text)' }}>
                {dominioGuardado}
              </div>
              <span style={{ fontSize: 12, padding: '4px 10px', borderRadius: 6, fontWeight: 600,
                background: dominioSsl ? '#0f2a1a' : '#2a2000',
                color: dominioSsl ? '#4ade80' : '#fbbf24',
                border: `1px solid ${dominioSsl ? '#2a5a3a' : '#5a4a00'}` }}>
                {dominioSsl ? '✓ SSL activo' : '⏳ Generando SSL...'}
              </span>
              <Btn variant="danger" style={{ padding: '6px 14px', fontSize: 12 }}
                onClick={async () => {
                  await fetch(`${API}/tenants/seo/dominio`, { method: 'DELETE', headers: headers() });
                  setDominioGuardado(null); setDominioSsl(false);
                }}>
                Desconectar
              </Btn>
            </div>
            {dominioSsl && (
              <div style={{ marginTop: 10, fontSize: 12, color: '#4ade80' }}>
                Tus páginas están disponibles en <strong>https://{dominioGuardado}/keyword-localidad</strong>
              </div>
            )}
          </div>
        ) : (
          <div>
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
              <input
                value={dominio}
                onChange={e => setDominio(e.target.value)}
                placeholder="seo.tudominio.com"
                style={{ flex: 1, minWidth: 200, padding: '10px 14px', borderRadius: 8, fontSize: 14,
                  background: '#0f1120', border: '1px solid #2a2e4a', color: 'var(--text)' }}
              />
              <Btn onClick={async () => {
                setDominioError(''); setDominioOk(''); setDominioLoading(true);
                try {
                  const r = await fetch(`${API}/tenants/seo/dominio`, {
                    method: 'POST', headers: headers(),
                    body: JSON.stringify({ dominio: dominio.trim() })
                  });
                  const d = await r.json();
                  if (!r.ok) { setDominioError(d.detail || 'Error'); return; }
                  setDominioGuardado(d.dominio);
                  setDominioSsl(false);
                  const poll = setInterval(async () => {
                    const rp = await fetch(`${API}/tenants/seo/dominio`, { headers: headers() });
                    const dp = await rp.json();
                    if (dp.ssl) { setDominioSsl(true); clearInterval(poll); }
                  }, 5000);
                  setTimeout(() => clearInterval(poll), 120000);
                } catch { setDominioError('Error de conexión.'); }
                finally { setDominioLoading(false); }
              }} disabled={dominioLoading || !dominio.trim()} style={{ whiteSpace: 'nowrap' }}>
                {dominioLoading ? 'Configurando...' : 'Conectar dominio'}
              </Btn>
            </div>
            {dominioError && <div style={{ marginTop: 10, fontSize: 13, color: '#f87171' }}>{dominioError}</div>}
            {dominioOk    && <div style={{ marginTop: 10, fontSize: 13, color: '#4ade80' }}>{dominioOk}</div>}
            {dominioLoading && (
              <div style={{ marginTop: 10, fontSize: 12, color: '#a78bfa' }}>
                ⏳ Verificando DNS y generando certificado SSL... esto puede tardar hasta 60 segundos.
              </div>
            )}
          </div>
        )}
      </div>

      {/* ── 3. Generación masiva (CTA principal) ── */}
      <Card style={{ marginBottom: 16 }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: 14 }}>
          <div style={{ fontWeight: 700, fontSize: 15, color: 'var(--text)' }}>⚡ Generación masiva</div>
          {bulkSugerencias && !bulkJobId && (
            <button onClick={() => { setBulkSugerencias(null); setBulkSeleccionadas([]); setBulkWarning(''); }}
              style={{ background:'none', border:'none', color:'var(--text2)', fontSize:13, cursor:'pointer' }}>
              ✕ Cancelar
            </button>
          )}
        </div>

        {bulkWarning && (
          <div style={{ marginBottom:14, padding:'10px 14px', borderRadius:8,
            background:'#2a2000', border:'1px solid #5a4a00', color:'#fbbf24', fontSize:13 }}>
            ⚠️ {bulkWarning}
          </div>
        )}

        {!bulkSugerencias && !bulkJobId && (
          <div>
            <p style={{ margin:'0 0 16px', fontSize:13, color:'var(--text2)', lineHeight:1.6 }}>
              La IA analiza el contexto de tu negocio, sector y zona para sugerir las mejores combinaciones
              keyword+localidad. Selecciona las que quieras y genera hasta <strong>10 páginas de golpe</strong>.
              Recomendamos lotes de 10 y esperar 2-3 semanas antes del siguiente para no saturar el crawl budget de Google.
            </p>
            <Btn onClick={sugerir} disabled={bulkSugeriendo}>
              {bulkSugeriendo ? '🔍 Analizando tu negocio...' : '⚡ Sugerir páginas'}
            </Btn>
          </div>
        )}

        {bulkSugerencias && !bulkJobId && (
          <div>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 }}>
              <span style={{ fontSize:13, color:'var(--text2)' }}>
                {bulkSeleccionadas.length} seleccionadas de {bulkSugerencias.filter(s => !s.existe).length} disponibles
              </span>
              <div style={{ display:'flex', gap:10 }}>
                <button onClick={() => setBulkSeleccionadas(bulkSugerencias.map((s,i) => !s.existe ? i : null).filter(i => i !== null))}
                  style={{ background:'none', border:'none', color:'#a78bfa', fontSize:12, cursor:'pointer' }}>
                  Todas
                </button>
                <button onClick={() => setBulkSeleccionadas([])}
                  style={{ background:'none', border:'none', color:'#a78bfa', fontSize:12, cursor:'pointer' }}>
                  Ninguna
                </button>
              </div>
            </div>
            <div style={{ maxHeight:340, overflowY:'auto', display:'flex', flexDirection:'column', gap:4 }}>
              {bulkSugerencias.map((s, i) => (
                <label key={i} style={{ display:'flex', alignItems:'center', gap:10, padding:'8px 12px',
                  borderRadius:6, background: s.existe ? '#111' : '#0f1120', border:'1px solid #2a2e4a',
                  cursor: s.existe ? 'default' : 'pointer', opacity: s.existe ? 0.45 : 1 }}>
                  <input type="checkbox" checked={bulkSeleccionadas.includes(i)} disabled={s.existe}
                    onChange={e => toggleSel(i, e.target.checked)} style={{ accentColor:'#7c3aed' }} />
                  <span style={{ flex:1, fontSize:13, color:'var(--text)' }}>{s.keyword}</span>
                  <span style={{ fontSize:12, color:'var(--text2)' }}>{s.localidad}</span>
                  {s.existe && <span style={{ fontSize:11, color:'#6b7280', marginLeft:4 }}>ya existe</span>}
                </label>
              ))}
            </div>
            <div style={{ marginTop:14, display:'flex', gap:12, alignItems:'center', flexWrap:'wrap' }}>
              <Btn onClick={generarBulk} disabled={bulkSeleccionadas.length === 0 || bulkGenerando}>
                ✦ Generar {bulkSeleccionadas.length} página{bulkSeleccionadas.length !== 1 ? 's' : ''}
              </Btn>
              <span style={{ fontSize:12, color:'#6b7280' }}>
                ~{Math.round(bulkSeleccionadas.length * 25)} seg estimados
              </span>
            </div>
          </div>
        )}

        {bulkJobId && (
          <div>
            <div style={{ fontSize:13, color:'var(--text)', marginBottom:10 }}>
              {bulkProgress.status === 'done'
                ? `✓ Completado — ${bulkProgress.total - bulkProgress.errors.length} páginas creadas`
                : `⏳ Generando... ${bulkProgress.done} de ${bulkProgress.total}`}
            </div>
            <div style={{ height:8, background:'#0f1120', borderRadius:4, overflow:'hidden', marginBottom:8 }}>
              <div style={{ height:'100%', borderRadius:4, transition:'width 0.4s ease',
                background: bulkProgress.status === 'done' ? '#4ade80' : '#7c3aed',
                width: bulkProgress.total > 0 ? `${(bulkProgress.done / bulkProgress.total) * 100}%` : '0%'
              }} />
            </div>
            {bulkProgress.errors.length > 0 && (
              <div style={{ fontSize:12, color:'#f87171', marginBottom:8 }}>
                {bulkProgress.errors.length} error{bulkProgress.errors.length !== 1 ? 'es' : ''}
              </div>
            )}
            {bulkProgress.status === 'done' && (
              <Btn variant="secondary" style={{ fontSize:12, marginTop:6 }}
                onClick={() => { setBulkJobId(null); setBulkProgress({ total:0, done:0, errors:[], status:'' }); }}>
                Nueva generación
              </Btn>
            )}
          </div>
        )}
      </Card>

      {/* ── 4. Añadir página manual (secundario) ── */}
      <details style={{ marginBottom: 24 }}>
        <summary style={{ cursor:'pointer', fontSize:13, color:'var(--text2)', padding:'10px 14px',
          borderRadius:8, background:'#0f1120', border:'1px solid #2a2e4a',
          listStyle:'none', display:'flex', alignItems:'center', gap:8, userSelect:'none' }}>
          <span style={{ color:'#a78bfa', fontSize:12 }}>▸</span>
          <span>Añadir página manualmente</span>
          <span style={{ marginLeft:'auto', fontSize:11, color:'#4b5563' }}>para casos puntuales</span>
        </summary>
        <div style={{ marginTop:8, padding:'16px 20px', borderRadius:8,
          background:'#0f1120', border:'1px solid #2a2e4a' }}>
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'flex-end' }}>
            <div style={{ flex: 1, minWidth: 180 }}>
              <label style={{ display: 'block', fontSize: 12, color: 'var(--text2)', marginBottom: 6, fontWeight: 600 }}>
                Keyword principal
              </label>
              <input
                value={keyword}
                onChange={e => setKeyword(e.target.value)}
                placeholder="ej: inmobiliaria en Madrid"
                style={{ width: '100%', padding: '10px 14px', borderRadius: 8, fontSize: 14,
                  background: '#1a1d2e', border: '1px solid #2a2e4a', color: 'var(--text)', boxSizing: 'border-box' }}
              />
            </div>
            <div style={{ flex: 1, minWidth: 160 }}>
              <label style={{ display: 'block', fontSize: 12, color: 'var(--text2)', marginBottom: 6, fontWeight: 600 }}>
                Localidad
              </label>
              <input
                value={localidad}
                onChange={e => setLocalidad(e.target.value)}
                placeholder="ej: Madrid"
                onKeyDown={e => e.key === 'Enter' && generar()}
                style={{ width: '100%', padding: '10px 14px', borderRadius: 8, fontSize: 14,
                  background: '#1a1d2e', border: '1px solid #2a2e4a', color: 'var(--text)', boxSizing: 'border-box' }}
              />
            </div>
            <Btn onClick={generar} disabled={generando} style={{ whiteSpace: 'nowrap' }}>
              {generando ? 'Generando...' : '✦ Generar'}
            </Btn>
          </div>
          {error && <div style={{ marginTop:10, padding:'8px 12px', borderRadius:6, background:'#3a1a1a', color:'#f87171', fontSize:13 }}>{error}</div>}
          {generando && <div style={{ marginTop:12, fontSize:13, color:'#c4b5fd' }}>⏳ Generando contenido SEO con IA... entre 15 y 30 segundos.</div>}
          {urlNueva && (
            <div style={{ marginTop:10, padding:'10px 14px', borderRadius:6, background:'#0f2a1a', border:'1px solid #2a5a3a', fontSize:13, color:'#4ade80', display:'flex', gap:10, flexWrap:'wrap' }}>
              <span>✓ Creada:</span>
              <a href={urlNueva} target="_blank" rel="noreferrer" style={{ color:'#86efac', textDecoration:'underline', wordBreak:'break-all' }}>{urlNueva}</a>
            </div>
          )}
        </div>
      </details>

      {/* ── 5. Lista de páginas ── */}
      <div style={{ fontWeight: 700, fontSize: 14, color: 'var(--text2)', marginBottom: 12, textTransform: 'uppercase', letterSpacing: '0.06em', display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:10 }}>
        <span>Páginas generadas ({paginas.length})</span>
        <div style={{ display:'flex', gap:8, alignItems:'center', flexWrap:'wrap' }}>
          {['7d','30d','90d'].map(p => (
            <button key={p} onClick={() => cambiarPeriodo(p)} style={{
              padding:'4px 12px', borderRadius:6, fontSize:12, cursor:'pointer', fontWeight:600,
              background: visitasPeriodo === p ? '#7c3aed' : '#0f1120',
              color: visitasPeriodo === p ? '#fff' : '#6b7280',
              border: visitasPeriodo === p ? '1px solid #7c3aed' : '1px solid #2a2e4a',
              textTransform:'none', letterSpacing:0,
            }}>{p}</button>
          ))}
          {paginas.length > 0 && (
          <a href={`${API}/tenants/seo/exportar-zip`}
            onClick={e => {
              e.preventDefault();
              fetch(`${API}/tenants/seo/exportar-zip`, { headers: headers() })
                .then(r => r.ok ? r.blob() : Promise.reject())
                .then(blob => {
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement('a');
                  a.href = url; a.download = 'paginas-seo.zip'; a.click();
                  URL.revokeObjectURL(url);
                })
                .catch(() => alert('Error al generar el ZIP'));
            }}
            style={{ fontSize:12, color:'#6b7280', textDecoration:'none', fontWeight:400,
              textTransform:'none', letterSpacing:0, padding:'4px 10px', borderRadius:6,
              border:'1px solid #2a2e4a', background:'#0f1120' }}>
            📦 Descargar ZIP
          </a>
          )}
        </div>
      </div>

      {loading && <div style={{ padding: 32, textAlign: 'center', color: 'var(--text2)', fontSize: 14 }}>Cargando...</div>}

      {!loading && paginas.length === 0 && (
        <Card>
          <div style={{ textAlign: 'center', padding: '24px 0', color: 'var(--text2)', fontSize: 14 }}>
            Aún no hay páginas. Usa la generación masiva para empezar.
          </div>
        </Card>
      )}

      {paginas.map(p => {
        const v = visitas[p.id];
        const expandida = visitasExpandida === p.id;
        const TIPO_LABEL = { real:'Usuarios', google:'Googlebot', bing:'Bing/DuckDuck', ia:'Bots IA', bot_otro:'Otros bots' };
        const TIPO_COLOR = { real:'#4ade80', google:'#60a5fa', bing:'#818cf8', ia:'#f59e0b', bot_otro:'#6b7280' };
        return (
        <Card key={p.id} style={{ marginBottom: 12 }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 16, flexWrap: 'wrap' }}>
            <div style={{ flex: 1, minWidth: 200 }}>
              <div style={{ fontWeight: 700, fontSize: 14, color: 'var(--text)', marginBottom: 4 }}>
                {p.title || p.keyword}
              </div>
              <div style={{ fontSize: 12, color: 'var(--text2)', marginBottom: 8 }}>
                {p.keyword} · {p.localidad}
                {p.tokens_used > 0 && (
                  <span style={{ marginLeft: 10, color: '#6b7280' }}>{p.tokens_used.toLocaleString()} tokens</span>
                )}
              </div>
              <a href={p.url} target="_blank" rel="noreferrer"
                style={{ fontSize: 12, color: '#a78bfa', wordBreak: 'break-all', textDecoration: 'none' }}>
                {p.url}
              </a>
            </div>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexShrink: 0 }}>
              <Btn variant="secondary" onClick={() => copiar(p.url, p.id)} style={{ padding: '6px 14px', fontSize: 12 }}>
                {copiado === p.id ? '✓ Copiado' : 'Copiar URL'}
              </Btn>
              <Btn variant="danger" onClick={() => eliminar(p.id)} style={{ padding: '6px 14px', fontSize: 12 }}>
                Eliminar
              </Btn>
            </div>
          </div>

          {/* ── Estadísticas de visitas ── */}
          {v ? (
            <div style={{ marginTop: 12, paddingTop: 12, borderTop: '1px solid #2a2e4a' }}>
              <div style={{ display:'flex', alignItems:'center', gap:16, flexWrap:'wrap', cursor:'pointer' }}
                onClick={() => setVisitasExpandida(expandida ? null : p.id)}>
                <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                  <span style={{ fontSize:13, fontWeight:700, color:'#4ade80' }}>👥 {v.total_real}</span>
                  <span style={{ fontSize:11, color:'#6b7280' }}>visitas reales</span>
                </div>
                {v.total_bots > 0 && (
                  <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                    <span style={{ fontSize:13, fontWeight:700, color:'#60a5fa' }}>🤖 {v.total_bots}</span>
                    <span style={{ fontSize:11, color:'#6b7280' }}>bots</span>
                  </div>
                )}
                {v.top_referrers.length > 0 && !expandida && (
                  <div style={{ fontSize:11, color:'#6b7280' }}>
                    📍 {v.top_referrers[0].dominio} ({v.top_referrers[0].visitas})
                  </div>
                )}
                <span style={{ marginLeft:'auto', fontSize:11, color:'#4b5563', userSelect:'none' }}>
                  {expandida ? '▲ menos' : '▼ detalle'}
                </span>
              </div>

              {expandida && (
                <div style={{ marginTop:12, display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>
                  <div>
                    <div style={{ fontSize:11, color:'#6b7280', marginBottom:8, fontWeight:600, textTransform:'uppercase', letterSpacing:'0.05em' }}>Por origen</div>
                    {Object.entries(v.por_tipo).sort((a,b) => b[1]-a[1]).map(([tipo, n]) => (
                      <div key={tipo} style={{ display:'flex', alignItems:'center', gap:8, marginBottom:6 }}>
                        <span style={{ width:8, height:8, borderRadius:'50%', background: TIPO_COLOR[tipo] || '#6b7280', flexShrink:0 }} />
                        <span style={{ fontSize:12, color:'var(--text)', flex:1 }}>{TIPO_LABEL[tipo] || tipo}</span>
                        <span style={{ fontSize:13, fontWeight:700, color: TIPO_COLOR[tipo] || '#6b7280' }}>{n}</span>
                      </div>
                    ))}
                  </div>
                  <div>
                    <div style={{ fontSize:11, color:'#6b7280', marginBottom:8, fontWeight:600, textTransform:'uppercase', letterSpacing:'0.05em' }}>
                      Top fuentes (tráfico real)
                    </div>
                    {v.top_referrers.length === 0 ? (
                      <div style={{ fontSize:12, color:'#4b5563' }}>Solo tráfico directo</div>
                    ) : v.top_referrers.map((r, i) => (
                      <div key={i} style={{ display:'flex', alignItems:'center', gap:8, marginBottom:6 }}>
                        <span style={{ fontSize:12, color:'var(--text)', flex:1 }}>{r.dominio}</span>
                        <span style={{ fontSize:13, fontWeight:700, color:'#4ade80' }}>{r.visitas}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div style={{ marginTop:10, paddingTop:10, borderTop:'1px solid #2a2e4a', fontSize:12, color:'#4b5563' }}>
              Sin visitas en {visitasPeriodo}
            </div>
          )}
        </Card>
        );
      })}

    </div>
  );
}